import React, { Component } from 'react'
import styles from '../styles/components/checkbox.module.scss';
import PropTypes from 'prop-types'

class Checkbox extends Component {
    render() {
        const disabledStyle = this.props.disabled ? styles.__disabled : '';
        return (
            <div className={styles.checkbox__bound}>
            <label className={styles.checkbox__label}>
                <input 
                    disabled={this.props.disabled}
                    name={this.props.name}
                    checked={this.props.check}
                    className={styles.checkbox} 
                    type='checkbox' 
                    onChange={this.props.onChange} 
                />
                <span className={[styles.checkbox__check, disabledStyle].join(' ')} />
                {this.props.label}
            </label>
            </div>
        )
    }
}

Checkbox.propTypes = {
    disabled: PropTypes.bool,
    check: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
}

export default Checkbox
